import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import qs from 'qs';

const SearchLink = ({ query, children }) =>
    <a href={`${process.env.REACT_APP_BASE_URL}/nos-formations/resultats?${qs.stringify({ query })}`}>{children}</a>
;

const SearchBox = ({ value, onChange, onClickClear, inputRef }) => {
    return (
        <div className="home-searchForm search-searchForm">
            <form noValidate action='' onSubmit={e => e.preventDefault()} role="search">
                <div className="input">
                    <input
                        ref={inputRef}
                        type="search"
                        className="toSuggest binded"
                        placeholder="Trouvez votre formation"
                        autoFocus
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        required=""
                        maxLength="512"
                        value={value}
                        onChange={onChange}
                    />
                    {value !== '' && (
                        <button
                            type="reset"
                            title="Effacer votre recherche"
                            className="ais-SearchBox-reset"
                            onClick={onClickClear}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    )}
                    <p className="exemples">
                        Ex.&nbsp;: <SearchLink query="Boucherie">Boucherie</SearchLink>,
                        {' '}<SearchLink query="Charcuterie">Charcuterie</SearchLink>,
                        {' '}<SearchLink query="Traiteur">Traiteur</SearchLink>,
                        {' '}<SearchLink query="Fromage coupe">Fromage coupe</SearchLink>,
                        {' '}<SearchLink query="Boulangerie">Boulangerie</SearchLink>,
                        {' '}<SearchLink query="Pâtisserie">Pâtisserie</SearchLink>,
                        {' '}<SearchLink query="Textile">Textile</SearchLink>,
                        {' '}<SearchLink query="Bazar permannent et saisonnier">Bazar permannent et saisonnier</SearchLink>,
                        {' '}<SearchLink query="Caisse">Caisse</SearchLink>,
                        {' '}<SearchLink query="Accueil">Accueil</SearchLink>,
                        {' '}<SearchLink query="Relation client">Relation client</SearchLink>,
                        {' '}<SearchLink query="Drive">Drive</SearchLink>,
                        {' '}<SearchLink query="Manangement">Management</SearchLink>,
                        {' '}<SearchLink query="CQP">CQP</SearchLink>...
                    </p>
                </div>
            </form>
        </div>
    );
};

SearchBox.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

SearchBox.defaultProps = {
    value: '',
};

export default SearchBox;